export const hasResizeObserver = () => typeof ResizeObserver !== 'undefined';
